// Episode page constants
export const EPISODE_CONSTANTS = {
  // Layout constants
  STICKY_HEADERS_HEIGHT: 320,
  CONTENT_MAX_WIDTH: {
    DEFAULT: "max-w-4xl",
    MINDMAP: "max-w-7xl",
    CLEANREAD: "max-w-3xl",
    VOCABULARY: "max-w-5xl",
    PHRASE: "max-w-5xl",
    SUMMARY: "max-w-3xl",
    SUMMARY_WITH_TRANSLATION: "max-w-5xl",
  },
  
  // Floating button positions
  FLOATING_BUTTONS: {
    RIGHT_POSITION: "right-2 sm:right-12",
    TOP_POSITION: "top-[430px] sm:top-[400px]",
    Z_INDEX: "z-40",
  },
  
  // Player control positions
  PLAYER_CONTROLS: {
    BOTTOM_POSITION: "bottom-4 sm:bottom-6",
    SIDE_POSITION: "left-2 sm:left-16 right-2 sm:right-16",
    Z_INDEX: "z-50",
  },
  
  // Animation and timing
  ANIMATION: {
    SUMMARY_UPDATE_INTERVAL: 100,
    BUFFER_MIN_LENGTH: 50,
    YOUTUBE_SEEK_DELAY: 100,
  },
  
  // Playback speeds
  PLAYBACK_SPEEDS: [0.5, 0.75, 1, 1.25, 1.5, 2],
  
  // Tab names
  TABS: {
    TRANSCRIPT: "Transcript",
    SUMMARY: "Summary",
    MINDMAP: "Mindmap",
    VOCABULARY: "Vocabulary",
    PHRASE: "Phrase",
    CLEANREAD: "Quiz",
  },
  
  // Practice mode types
  PRACTICE_MODES: {
    VOCABULARY: "vocabulary" as const,
    TOEFL: "toefl" as const,
  },
} as const;

// CSS styles as constants
export const EPISODE_STYLES = {
  noScrollbar: `
    .no-scrollbar::-webkit-scrollbar {
      display: none;
    }
    .no-scrollbar {
      -ms-overflow-style: none;  /* IE and Edge */
      scrollbar-width: none;  /* Firefox */
    }
  `,
  
  // Background styles
  glassmorphism: {
    backgroundColor: "rgba(255,255,255,0.25)",
    backdropFilter: "blur(8px) saturate(1.5)",
    WebkitBackdropFilter: "blur(8px) saturate(1.5)",
  },
  
  // Button styles
  buttonClasses: {
    floatingButton: "h-8 w-8 sm:h-10 sm:w-10 rounded-[10px] sm:rounded-xl shadow-sm",
    playerButton: "h-11 w-11 sm:h-10 sm:w-10 rounded-xl hover:bg-white/50 hover:border border-zinc-400",
    active: "bg-primary hover:bg-primary text-primary-foreground",
    inactive: "dark:bg-primary/30 hover:bg-gray-50",
  },
} as const;

// Error messages
export const EPISODE_ERRORS = {
  CONTENT_NOT_AVAILABLE: "Content not available for generation",
  VOCABULARY_REQUIRED: "Please generate vocabulary first",
  TOEFL_LOADING_FAILED: "无法加载TOEFL词库，请重试",
  VOCAB_CHECKER_INIT_FAILED: "初始化词汇检查器失败",
} as const; 
